import {
  endOfDay,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
  subYears,
} from 'date-fns';
import { twMerge } from 'tailwind-merge';

import { PresetItem } from './PresetItem';

const today = new Date();
const eod = endOfDay(today);

const presets = {
  Today: [startOfDay(today), eod] as const,
  Yesterday: [startOfDay(subDays(today, 1)), endOfDay(subDays(today, 1))] as const,
  'This Week': [startOfDay(startOfWeek(today)), eod] as const,
  'Last Week': [startOfDay(startOfWeek(subWeeks(today, 1))), endOfDay(endOfWeek(subWeeks(today, 1)))] as const,
  'This Month': [startOfDay(startOfMonth(today)), eod] as const,
  'Last Month': [startOfDay(startOfMonth(subMonths(today, 1))), endOfDay(endOfMonth(subMonths(today, 1)))] as const,
  'This Year': [startOfDay(startOfYear(today)), eod] as const,
  'Last Year': [startOfDay(startOfYear(subYears(today, 1))), endOfDay(endOfYear(subYears(today, 1)))] as const,
};

const presetKeys = Object.keys(presets) as (keyof typeof presets)[];

interface PresetProps {
  readonly onClick: (start: Date, end: Date) => void;
  readonly className?: string;
}

function Preset({ onClick, className }: PresetProps) {
  const classes = twMerge('flex flex-col p-6', className);

  return (
    <div className={classes}>
      {presetKeys.map((key, i) => (
        <PresetItem key={key} onClick={() => onClick(...presets[key])} className={i !== 0 ? 'mt-1' : undefined}>
          {key}
        </PresetItem>
      ))}
    </div>
  );
}

export { Preset, presets };
